// Angular
import { Component, OnInit } from '@angular/core';

// localforage
import * as localforage from 'localforage';

// Services
import { ApiService } from '@app/services/api/api.service';

@Component({
  selector: 'oh-survey-thanks',
  templateUrl: './survey-thanks.component.html',
  styleUrls: ['./survey-thanks.component.scss'],
})
export class SurveyThanksComponent implements OnInit {
  private data: any;
  public info: any;

  constructor(private apiService: ApiService) {}

  async ngOnInit() {
    this.data = await this.apiService.getAgentDataFromDatabase();
    this.info = this.data;
  }
}
